import './index';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Propos from './pages/Propos';
import Service from './pages/Service';
import Realisation from './pages/Realisation';
import Carriere from './pages/Carriere';
import NousJoindre from './pages/NousJoindre';  
import InfoRealisation from './pages/InfoRealisation';
import ErrorPage from './pages/ErrorPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/propos" element={<Propos />} />
          <Route path="/services" element={<Service />} />
          <Route path="/realisations" element={<Realisation />} />
          <Route path="/carriere" element={<Carriere />} />
          <Route path="/nousjoindre" element={<NousJoindre />} />
          <Route path="/realisation/:id" element={<InfoRealisation />} />
          <Route path="/400" element={<ErrorPage code={400} />} />
          <Route path="/401" element={<ErrorPage code={401} />} />
          <Route path="/403" element={<ErrorPage code={403} />} />
          <Route path="/404" element={<ErrorPage code={404} />} />
          <Route path="*" element={<ErrorPage code={404} />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
